import CartIcon from '../../../../../ui/svg/shopping-cart/cart';
import UndoCartItems from '../step-1/undo-cart-items/undo-cart-items';
import React from 'react';

const EmptyCart = () => {
    return (
        <div>
            <UndoCartItems />
            <div className="flex items-center justify-center p-4 my-20">
                <CartIcon width="80px" color="#1d1d1d" classes="mr-4" />
                <div className="text-xl">
                    <p>Your cart is empty</p>
                    <p className="inapp-hidden"><a href="/subscriptions" title="">Get access to all Waves plugins</a></p>
                </div>
            </div>
        </div>
    )
};

export default EmptyCart;